import { render } from "./VsInputNumber.vue?vue&type=template&id=3b6c4a82"
import script from "./VsInputNumber.vue?vue&type=script&lang=js"
export * from "./VsInputNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__